import * as XLSX from 'xlsx/xlsx.mjs'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { fields } from '../components/printTemplateData'
import { batchEditTagContent } from '@/apis/order'

interface ValidateSkuRepeatParams{
  excelTable: Record<string, string>[];
  onStopUpload: () => void;
}

interface props {
  headers: Array<string>,
  excel: File,
  deliverTaskDetails: Array<any>
  validateSkuRepeat?: (params: ValidateSkuRepeatParams) => Promise<boolean | undefined>
}

export interface excelError {
  line: number,
  arrange: string,
  msg: string
}

interface validExcelPromise {
  success: boolean,
  excelList: Array<excelError>
}

enum str2field {
  sku = 'THE CKB SKU'
}

export const validExcel = (props: props) => {
  const { validateSkuRepeat } = props
  return new Promise<validExcelPromise>((resolve, reject) => {
    const { headers, excel, deliverTaskDetails } = props
    const reader = new FileReader()
    const errorList = <excelError[]>[]

    reader.onload = async function (e: any) {
      const data = e.target.result
      const workbook = XLSX.read(data, { type: 'binary' })
      const SKUfileJson: (any) = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]) // excel数据
      const excelHeaders: (any) = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 })[0] // excel表头
      const tableDataMapping = deliverTaskDetails.map((item: any) => {
        return item.productSku
      })
      // // // // // // // // // // // // // // // // // // //
      // if (validateSkuRepeat) {
      //   await validateSkuRepeat({
      //     excelTable: SKUfileJson,
      //     onStopUpload: function () {
      //       resolve({ success: false, excelList: errorList })
      //     }
      //   })
      // }
      // // // // // // // // // // // // // // // // // // //
      // 表头
      if (excelHeaders.length !== headers.length || excelHeaders.some((t: any) => !headers.includes(t))) {
        ElMessage.warning(t('文件字段与模板字段不一致，请检查后重新上传'))
        resolve({ success: false, excelList: errorList })
        return
      }
      // 内容
      if (!SKUfileJson.length) {
        ElMessage.warning(t('excel内容为空'))
        resolve({ success: false, excelList: errorList })
        return
      }
      SKUfileJson.forEach((v: any, index: number) => {
        // 表头+1 下表+1
        const line = index + 2
        // SKU对不上
        if (tableDataMapping.every((t: any) => t !== v[str2field.sku])) {
          errorList.push({
            line: line,
            arrange: String.fromCharCode(64 + headers.length),
            msg: t('商品列表不存在此SKU，请删除')
          })
          return
        }
        const PriceName = fields.filter(v => v.key === 'price')[0].name
        const UPCName = fields.filter(v => v.key === 'UPC')[0].name
        excelHeaders.forEach((y:string, index: number) => {
          // 空值
          if (!v[y]) {
            errorList.push({
              line: line,
              arrange: String.fromCharCode(64 + index + 1),
              msg: t('数据不完整')
            })
            return
          }
          // price必须为正数
          if (y === PriceName && (isNaN(Number(v[y])) || Number(v[y]) < 0)) {
            errorList.push({
              line: line,
              arrange: String.fromCharCode(64 + index + 1),
              msg: t('price必须为正数')
            })
            return
          }
          // 商品条码必须是数字
          if (y === UPCName && !/^[0-9]*$/g.test(v[y])) {
            errorList.push({
              line: line,
              arrange: String.fromCharCode(64 + index + 1),
              msg: t('条形码必须为数字')
            })
            return
          }
          // 字符长度超过50
          if (String(v[y]).length > 50) {
            errorList.push({
              line: line,
              arrange: String.fromCharCode(64 + index + 1),
              msg: t('字段长度大于50，请删减')
            })
          }
        })
      })
      if (errorList.length > 0) {
        resolve({ success: false, excelList: errorList })
        return
      }
      // TODO sku 重复校验写这里
      if (validateSkuRepeat) {
        await validateSkuRepeat({
          excelTable: SKUfileJson,
          onStopUpload: function () {
            resolve({ success: false, excelList: errorList })
          }
        })
      }
      resolve({ success: true, excelList: SKUfileJson })
    }
    reader.onerror = function (e: any) {
      ElMessage.warning(t('仅支持xlsx文件，请检查后重新上传'))
      reject(e)
    }
    reader.readAsBinaryString(excel)
  })
}

interface updateFormListProp {
  excelList: Array<any>,
  deliverTaskDetails: Array<any>
}
export const updateFormList = async (props: updateFormListProp) => {
  const finalFields = fields.map(v => {
    return {
      name: v.name,
      key: v.key
    }
  }).concat([
    {
      name: 'THE CKB SKU',
      key: 'productSku'
    }
  ])
  console.log(finalFields)
  const { excelList, deliverTaskDetails } = props
  const transExcelList = excelList.map(v => {
    const vCache = <any>{}
    Object.keys(v).forEach(y => {
      const targetField = finalFields.filter(i => i.name === y)[0]?.key
      targetField && (vCache[targetField] = v[y])
    })
    return vCache
  })
  console.log(transExcelList)
  const params = <any>[]
  const transDeliverTaskDetails = deliverTaskDetails.map(v => {
    const targetExcelData = transExcelList.filter(y => y.productSku === v.productSku)[0]
    if (!targetExcelData) {
      return {
        ...v
      }
    }
    params.push({
      shopProductSku: v.shopProductSku,
      tagContent: [targetExcelData],
      type: 4
    })
    return {
      ...v,
      skuTagDTOList: [{
        tagContent: JSON.stringify([targetExcelData])
      }]
    }
  })
  const res = await batchEditTagContent(params)
  if (res.success) {
    return transDeliverTaskDetails
  }
  return deliverTaskDetails
}

export const checkPackingStatus = (obj:any, templateJson:any) => {
  if (!JSON.parse(obj?.skuTagDTOList[0]?.tagContent)[0]) {
    return false
  }
  return templateJson.filter((v:any) => v.field).every((v:any) => {
    return (<any>Object).hasOwn(JSON.parse(obj.skuTagDTOList[0].tagContent)[0], v.field)
  })
}
